import Layout from '@/layout';

const menuRouter = [{
	path: "/contribution",
	component: () => import("@/views/contribution/mycontributions.vue"),
	meta: {
		auth: 65536,
		title: "投稿管理",
		content: {
			keywords: "",
			description: "",
		}
	},
	name: "投稿管理",
}, {
	path: "/submitcontribution",
	component: () => import("@/views/contribution/submitcontribution.vue"),
	meta: {
		auth: 65536,
		title: "杂志志稿",
		content: {
			keywords: "",
			description: "",
		}
	},
	name: "杂志志稿",
}];

export default [{
	path: "/",
	component: Layout,
	children: [...menuRouter]
}];
